import React, { useEffect, useState } from "react";
import {
  CartNewIcon,
  LeftArrowIcon,
  StblPaymentIcon,
} from "../../../../assets/icons/svgicons";
import Button from "../../Button/Button";
import PaymentCompleted from "../../Modals/PaymentCompleted/PaymentCompleted";
import styles from "./Cart.module.scss";
import Overview from "./Overview/Overview";
import Payment from "./Payment/Payment";
import { toFix, formattedPrice } from "../../../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { marketPlaceCheckoutAction } from "../../../../features/marketPlace/marketPlaceSlice";
import {
  getMarketplaceFeeAction,
  getUserWalletBalanceAction,
  getWalletBalanceAction,
} from "../../../../features/user/userSlice";
import { STATUS_CODE } from "../../../../utils/constants";
import { getUserCoinListAction } from "../../../../features/user/userSlice";
import { saveCartCount } from "../../../../features/persist/persistSlice";
import Modal from "../../Modals/Modal/Modal";

const Cart = ({ show, handleClose }) => {
  const dispatch = useDispatch();
  const spotPrice = useSelector((state) => state?.users?.spotPrice);
  const coinRates = useSelector((state) => state?.users?.coinRates);
  const userData = useSelector((state) => state?.persist?.userInfo);
  const spotPremiumPrice = useSelector((state) => state?.users?.spotPremiumPrice);
  const commonBalance = useSelector((state) => state?.users?.commonWalletBalance?.amount);
  const cryptoPrices = useSelector((state) => state?.users?.cryptoPrice);


  const premiumFee = useSelector((state) => state?.users?.premiumFee); // Added to define premiumFee
  const [step, setStep] = useState(0);
  const [showTransactionDone, setShowTransactionDone] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [tax, setTax] = useState(0);
  const [fees, setFees] = useState({ fee: 0, taxes: 0 });
  const [grandTotal, setGrandTotal] = useState(0);
  const [paymentMode, setPaymentMode] = useState("STBL Wallet");
  const [marketPlaceFee, setMarketPlaceFee] = useState("");
  const [cartList, setCartList] = useState([]);
  const [txnId, setTxnId] = useState("");
  const [errorProductId, setErrorProductId] = useState([]);
  const [coinOptions, setCoinOptions] = useState([]);
  const [coinList, setCoinList] = useState([]);
  const [totalRangeFees, setTotalRangeFees] = useState(0);

  const fetchCoinOptions = async () => {
    try {
      const response = await dispatch(getUserCoinListAction());
      if (response.data.status === STATUS_CODE.successful) {
        const array = [];
        const newData = response.data.data.coinList;
        setCoinList(newData);
        newData?.map((coin) => {
          array.push({
            value: coin.id,
            label: coin.coin_symbol,
            networkdetails: coin.networkDetail,
            coinImage: coin.coinStats[0]?.image_path,
          });
        });
        setCoinOptions(array);
      }
    } catch (error) {
      console.error("Error fetching coin options:", error);
    }
  };

  useEffect(() => {
    fetchCoinOptions();
  }, []);

  const handleCloseCart = () => {
    handleClose();
    setPaymentMode("");
    setTimeout(() => {
      setStep(0);
    }, 500);
  };

  const getWalletBalance = async () => {
    try {
      await dispatch(getUserWalletBalanceAction());
    } catch (error) {
      console.log(error);
    }
  };

  const handlePlaceOrder = async () => {
    let itemsArray = [];
    if (!Array.isArray(premiumFee)) {
      console.error("premiumFee is not an array or is undefined:", premiumFee);
      // Proceed with default fee of 0
      cartList.forEach((item, i) => {
        itemsArray[i] = {
          productId: item?.product_id,
          tokenId: item?.product?.token_id,
          quantity: Number(item.quantity),
          price: item?.price,
          cartId: item?.id,
          tokenName: item?.master_tokens_configuration?.name,
          adminPremiumFee: 0, // Default to 0 if premiumFee is undefined
          sellerPremiumFee: 0,
          marketPlaceFee: Number(marketPlaceFee),
          selectionMode: item?.selection_mode,
          modeValue: Number(item.quantity * item?.price),
        };
      });
    } else {
      cartList.forEach((item, i) => {
        let premiumPrice = premiumFee.filter(
          (elem) => elem.token_id === item?.token_id
        )[0];

        itemsArray[i] = {
          productId: item?.product_id,
          tokenId: item?.product?.token_id,
          quantity: Number(item.quantity),
          price: item?.price,
          cartId: item?.id,
          tokenName: item?.master_tokens_configuration?.name,
          adminPremiumFee: Number(premiumPrice?.fee_value || 0),
          sellerPremiumFee: 0,
          marketPlaceFee: Number(marketPlaceFee),
          selectionMode: item?.selection_mode,
          modeValue: Number(item.quantity * item?.price),
        };
      });
    }

    const coin = paymentMode === "STBL Wallet"
      ? "STBL"
      : paymentMode;


    let coinPrice =
      coin === "STBL"
        ? 1
        : Number(coinRates?.[PRICE_KEY_MAP[coin]] || 0);

    let coinQuantity =
      coin === "STBL"
        ? Number(grandTotal)
        : Number(grandTotal / coinPrice);


    if (!coin) {
      console.error("Invalid payment mode selected.");
      return;
    }

    const calcAmount = itemsArray.reduce((sum, item) => {
      return sum + Number(item.price) * item.quantity;
    }, 0);

    let dataObj = {
      fees: fees.fee,
      tax: fees.taxes,
      amount: (
        calcAmount +
        marketPlaceFee * cartList?.length +
        totalRangeFees
      ).toFixed(2),
      totalAmount: (
        calcAmount +
        marketPlaceFee * cartList?.length +
        totalRangeFees
      ).toFixed(2),
      items: itemsArray,
      type: coin === "STBL" ? "WIRE" : "CRYPTO",
      coin: coin,
      coinQuantity: coinQuantity,
      coinPrice: coinPrice,
    };


    try {
      const response = await dispatch(marketPlaceCheckoutAction(dataObj));
      if (response.status === 200) {
        dispatch(getWalletBalanceAction());
        handleCloseCart();
        setTxnId(response.data.data.transactionId);
        setShowTransactionDone(true);
        dispatch(saveCartCount(0));

        // Partnero Transaction Tracking
        if (window.po && typeof window.po === "function") {

          try {
            const partneroData = {
              data: {
                key: response.data.data.transactionId, // Transaction ID
                amount: Number(dataObj.totalAmount), // Total amount
                amount_units: "usd", // Currency code
                customer: {
                  key: userData?.email, // User identifier
                },
              },
            };


            window.po("transactions", "create", partneroData);
          } catch (error) {
            console.error("Error during Partnero transaction tracking:", {
              error: error.message,
              transactionId: response.data.data.transactionId,
              userEmail: userData?.email,
              totalAmount: Number(dataObj.totalAmount),
            });
          }
        } else {
          console.warn("⚠️ Partnero 'po' function not found on window. Ensure Partnero script is loaded.");
        }
      } else {
        console.error("Checkout API failed with status:", response.status, response);
      }
    } catch (error) {
      console.error("Error placing order:", {
        error: error.message,
        stack: error.stack,
        dataObj: JSON.stringify(dataObj, null, 2),
      });
    }
  };

  const getRangePrice = (qty, priceChart, paymentMode) => {
    if (!priceChart || priceChart.length === 0) {
      return 0;
    }
    const qtyNum = Number(qty);
    const matchingPrice = priceChart.find(
      (priceRange) =>
        qtyNum >= priceRange.min_quantity && qtyNum <= priceRange.max_quantity
    );

    if (matchingPrice) {
      const fee =
        paymentMode === "MATIC" || paymentMode === "USDC" || paymentMode === "USDT"
          ? Number(matchingPrice.crypto_payment_price || 0)
          : Number(matchingPrice.stripe_payment_price || 0);
      return fee;
    }
    return 0;
  };

  const updateCartItem = (updatedItem) => {
    setCartList((prevCartList) =>
      prevCartList.map((item) =>
        item.id === updatedItem.id ? { ...item, ...updatedItem } : item
      )
    );
  };

  const components = [
    {
      cartHeading: "Your Cart",
      heading: "Overview",
      icon: <CartNewIcon />,
      component: (
        <Overview
          closeCart={handleCloseCart}
          setSubTotal={setSubTotal}
          setTax={setTax}
          cartList={cartList}
          setCartList={setCartList}
          getRangePrice={getRangePrice}
          coinLists={coinList}
          paymentMode={paymentMode}
          updateCartItem={updateCartItem}
        />
      ),
    },
    {
      cartHeading: "Select Payment",
      heading: "Payment",
      icon: <StblPaymentIcon />,
      component: (
        <Payment
          setPaymentMode={setPaymentMode}
          cartList={cartList}
          grandTotal={grandTotal}
          commonBalance={commonBalance}
          cryptoPrices={cryptoPrices}
        />
      ),
    },
  ];

  const getMarketplaceFee = async () => {
    try {
      const response = await dispatch(getMarketplaceFeeAction());
      if (response?.status === 200) {
        const mkFee = response.data.data;
        setMarketPlaceFee(mkFee);
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  useEffect(() => {
    if (!cartList.length) {
      setTotalRangeFees(0);
      setSubTotal(0);
      setGrandTotal(0);
      setErrorProductId([]);
      return;
    }

    const rangeFees = cartList.reduce((sum, item) => {
      const qtyNum = Number(item.quantity);
      const fee = getRangePrice(qtyNum, item.product_price_chart, paymentMode);
      const itemRangeFee = fee * qtyNum;
      return sum + itemRangeFee;
    }, 0);
    setTotalRangeFees(rangeFees);

    const hasInvalidRangeFees = cartList.some(
      (item) =>
        getRangePrice(
          Number(item.quantity),
          item.product_price_chart,
          paymentMode
        ) === 0
    );
    if (hasInvalidRangeFees) {
      setErrorProductId((prev) => [
        ...new Set([
          ...prev,
          ...cartList
            .filter(
              (item) =>
                getRangePrice(
                  Number(item.quantity),
                  item.product_price_chart,
                  paymentMode
                ) === 0
            )
            .map((item) => item.id),
        ]),
      ]);
    } else {
      setErrorProductId([]);
    }

    const subTotalCalc = cartList.reduce((total, item) => {

      const { token_id, quantity, selection_mode } = item;

      const basePrice =
        token_id == 1
          ? spotPremiumPrice?.goldPrice || 0
          : spotPremiumPrice?.silverPrice || 0;

      const qtyNum = Number(quantity || 0);

      // ✅ Same formula for BOTH modes
      return total + basePrice * qtyNum;
    }, 0);

    setSubTotal(subTotalCalc);


    setGrandTotal(
      subTotalCalc + fees.fee + marketPlaceFee * cartList.length + rangeFees
    );
  }, [cartList, spotPrice, spotPremiumPrice, marketPlaceFee, fees.fee, paymentMode]);

  useEffect(() => {
    getMarketplaceFee();
    getWalletBalance();
    dispatch(getWalletBalanceAction());
  }, []);

  const getMaxQuantityFromProductPrices = (productData) => {
    const maxQuantities =
      productData?.product_price_chart?.map((price) => price.max_quantity) || [];
    return maxQuantities.length > 0 ? Math.max(...maxQuantities) : 0;
  };

  useEffect(() => {
    if (cartList.length > 0) {
      const idArray = cartList
        .filter(
          (item) => Number(item.quantity) > getMaxQuantityFromProductPrices(item)
        )
        .map((item) => item.id);
      setErrorProductId((prev) => [...new Set([...prev, ...idArray])]);
    } else {
      setErrorProductId([]);
    }
  }, [cartList]);

  const isBelowMinOrderQty = () => {
    return cartList.some((item) => {
      const coin = coinList.find(
        (coin) => coin.coin_symbol === item.master_tokens_configuration?.name
      );
      if (!coin) return false;
      return Number(item.quantity) < coin.min_order_qty;
    });
  };

  const totalAmount =
    Number(subTotal) +
    Number(marketPlaceFee * cartList?.length) +
    Number(totalRangeFees);

  const isInsufficientBalance = () => {
    // STBL Wallet
    if (paymentMode === "STBL Wallet") {
      return Number(totalAmount) > Number(commonBalance);
    }

    const selectedCoin = coinList.find(
      (coin) => coin.coin_symbol === paymentMode
    );
    if (!selectedCoin) return true;

    const priceKey = PRICE_KEY_MAP[paymentMode];
    const coinPrice = coinRates?.[priceKey];

    if (!coinPrice || coinPrice <= 0) return true;

    const requiredQty = Number(totalAmount) / Number(coinPrice); return requiredQty > Number(selectedCoin.balance);
  };



  const PRICE_KEY_MAP = {

    USDT: "usdtPrice",
    USDC: "usdcPrice",
    MATIC: "maticPrice",
  };






  return (
    <>
      <Modal
        show={show}
        hideCloseBtn
        handleClose={handleCloseCart}
        title={<>
          <div className="headig_top">
            {/* <Button variant='without_bg_border' className='back_btn' onClick={() => { setStep(step - 1); setPaymentMode(""); }} >
              <LeftArrowIcon /> Back
            </Button> */}

            {components[step].cartHeading}
          </div>
        </>}
        className={styles.cart}
      >
        <div className={styles.cart_body}>
          {cartList.length > 0 && (
            <div className={`${styles.cart_nav} ${step > 0 ? styles.stepCompleted : ""}`}>
              {components.map((item, index) => {
                const isCompleted = index < step;
                return (
                  <button
                    key={item.cartHeading}
                    className={`${index === step ? styles.active : ""} ${isCompleted ? "clickable" : ""} ${isCompleted ? styles.completed : ""}`}
                    onClick={() => { if (isCompleted) { setStep(index); setPaymentMode(""); } }}
                  >
                    <span>{item.icon}</span>
                    {item.heading}
                  </button>
                );
              })}
            </div>
          )}
          <div className={styles.cart_content}>
            {components[step].component}
          </div>
          {cartList.length > 0 && (
            <div className={styles.cart_footer}>
              <ul>
                <li>
                  <p>Subtotal:</p>
                  <h6>{toFix(formattedPrice(Number(subTotal)))}</h6>
                </li>
                {/* <li>
                  <p>Marketplace Fees:</p>
                  <h6 className={styles.addSubtext}>
                    {toFix(
                      formattedPrice(Number(marketPlaceFee * cartList?.length))
                    )}
                  </h6>
                </li> */}
                <li>
                  {/* <p>Range Fees:</p>
                  <h6 className={styles.addSubtext}>
                    {toFix(formattedPrice(Number(totalRangeFees)))}
                  </h6> */}
                  <p>Platform Fees:</p>
                  <h6 className={styles.addSubtext}>
                    {toFix(formattedPrice(Number(totalRangeFees) + (Number(marketPlaceFee * cartList?.length))))}
                  </h6>
                </li>
                <li className={styles.cardtotellist}>
                  <p>Total Amount (Fiat):</p>
                  <h6>
                    {toFix(
                      formattedPrice(
                        Number(subTotal) +
                        Number(marketPlaceFee * cartList?.length) +
                        Number(totalRangeFees)
                      ),
                      2
                    )}
                  </h6>
                </li>
                {paymentMode === "BTC" && cryptoPrices.btcPrice && (
                  <li>
                    <h6>
                      {toFix(Number(grandTotal / cryptoPrices.btcPrice), 5)} BTC
                    </h6>
                  </li>
                )}
                {paymentMode === "ETH" && cryptoPrices.ethPrice && (
                  <li>
                    <h6>
                      {toFix(Number(grandTotal / cryptoPrices.ethPrice), 5)} ETH
                    </h6>
                  </li>
                )}
              </ul>
            </div>
          )}
          <div className={styles.btnSec}>
            {step !== 1 ? (
              cartList.length > 0 && (
                <Button
                  // disabled={
                  //   cartList.length === 0 ||
                  //   errorProductId.length > 0 ||
                  //   isBelowMinOrderQty()
                  // }
                  fluid
                  className={styles.continue_btn}
                  onClick={() => setStep(step + 1)}
                >
                  Continue
                </Button>
              )
            ) : (
              <Button
                fluid
                className={styles.continue_btn}
                onClick={handlePlaceOrder}
                disabled={isInsufficientBalance()}

              >
                Place Order
              </Button>
            )}
          </div>
        </div>
      </Modal>
      {/* <Offcanvas
        show={show}
        onHide={handleCloseCart}
        placement="end"
        className={styles.cart}
      >
        <Offcanvas.Header className={styles.cart_header}>
          <h3>{components[step].cartHeading}</h3>
          <button onClick={handleCloseCart} className={styles.close_btn}>
            <CloseIcon />
          </button>
        </Offcanvas.Header>
        <Offcanvas.Body className={styles.cart_body}>
          {cartList.length > 0 && (
            <div className={styles.cart_nav}>
              {components.map((item, index) => (
                <button
                  key={item.cartHeading}
                  className={`${index === step ? styles.active : ""} ${index < step ? "clickable" : ""
                    }`}
                  onClick={() => {
                    index < step && setStep(index);
                    setPaymentMode("");
                  }}
                >
                  <span>{item.icon}</span>
                  {item.heading}
                </button>
              ))}
            </div>
          )}
          <div className={styles.cart_content}>
            {components[step].component}
          </div>
          <div className={styles.cart_footer}>
            {cartList.length > 0 && (
              <ul>
                <li>
                  <p>Subtotal:</p>
                  <h6>{toFix(formattedPrice(Number(subTotal)))}</h6>
                </li>
                <li>
                  <p>Marketplace Fees:</p>
                  <h6 className={styles.addSubtext}>
                    {toFix(
                      formattedPrice(Number(marketPlaceFee * cartList?.length))
                    )}
                  </h6>
                </li>
                <li>
                  <p>Range Fees:</p>
                  <h6 className={styles.addSubtext}>
                    {toFix(formattedPrice(Number(totalRangeFees)))}
                  </h6>
                </li>
                <li>
                  <p>Total Amount (Fiat):</p>
                  <h6>
                    {toFix(
                      formattedPrice(
                        Number(subTotal) +
                        Number(marketPlaceFee * cartList?.length) +
                        Number(totalRangeFees)
                      ),
                      2
                    )}
                  </h6>
                </li>
                {paymentMode === "BTC" && cryptoPrices.btcPrice && (
                  <li>
                    <h6>
                      {toFix(Number(grandTotal / cryptoPrices.btcPrice), 5)} BTC
                    </h6>
                  </li>
                )}
                {paymentMode === "ETH" && cryptoPrices.ethPrice && (
                  <li>
                    <h6>
                      {toFix(Number(grandTotal / cryptoPrices.ethPrice), 5)} ETH
                    </h6>
                  </li>
                )}
              </ul>
            )}
            {step !== 1 ? (
              cartList.length > 0 && (
                <Button
                  // disabled={
                  //   cartList.length === 0 ||
                  //   errorProductId.length > 0 ||
                  //   isBelowMinOrderQty()
                  // }
                  fluid
                  className={styles.continue_btn}
                  onClick={() => setStep(step + 1)}
                >
                  Continue
                </Button>
              )
            ) : (
              <Button
                fluid
                className={styles.continue_btn}
                onClick={handlePlaceOrder}
              // disabled={
              //   !paymentMode ||
              //   errorProductId.length > 0 ||
              //   isBelowMinOrderQty()
              // }
              >
                Place Order
              </Button>
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas> */}
      <PaymentCompleted
        txnId={txnId}
        show={showTransactionDone}
        handleClose={() => setShowTransactionDone(false)}
        closeCart={handleCloseCart}
        paymentType="MARKETPLACE"
      />
    </>
  );
};

export default Cart;
